import styled from "styled-components";

export const Container = styled.div`
  width: 36px;
  height: 36px;
  background-color: ${props => props.backgroundColor};
`